export const Constants = {
  clientData: 'Dados do cliente',
  clientName: 'proprietário do imóvel:',
  bankClientName: 'proponente / cliente:',
  solicitor: 'solicitante',
  clientType: 'tipo do cliente:',
  evaluationType: 'tipo do cálculo:',
  goal: 'objetivo:',
  function: 'finalidade:',
  propertyUse: 'uso do imóvel:',
  inspectionType: 'modalidade da vistoria',
};
